module.exports = __webpack_public_path__ + "img/tmlogo.b2e61866.png";